import classNames from 'classnames';

import { INPUT_TEXT_ALIGN, BORDER_PROP_BY_TYPE } from './constants';

import '../Form.scss';
import { TextField } from '@conekta/frontino-ui/TextField/TextField';
import { IInputForm } from 'app/pages/frames/components/Form/interface';
import { useContext } from 'react';
import { DefaultTheme, ThemeContext } from 'styled-components';

import './styles.scss';
import { NumberFormatCustom } from 'app/components/NumberFormatCustom';
import { TextFieldWrapper } from 'app/pages/frames/components/styled-components/TextFieldWrapper';

export const InputForm = (props: IInputForm) => {
  const {
    alignInput,
    classNameFieldset,
    descriptionField,
    input,
    labelOptions,
    maxLength,
    meta: { active, error, touched, valid },
    placeholder,
    onChange,
    format,
    prefix,
    backgroundImage = '',
    fullWidth,
    ...rest
  } = props;
  const { value, onChange: inputOnChange } = input;
  const THEME_CONTEXT: DefaultTheme = useContext(ThemeContext);
  const inputType = BORDER_PROP_BY_TYPE[THEME_CONTEXT.inputType] || BORDER_PROP_BY_TYPE.basic;
  const isInputEmpty: boolean = value === '';

  const handleOnChange = (event: Event) => {
    inputOnChange(event);
    onChange && onChange(event);
  };

  const inputComponent = (formatComponent?: string, prefixComponent?: string) =>
    formatComponent || prefixComponent ? NumberFormatCustom : undefined;

  const inputProps = {
    activate: error && touched,
    className: classNames(
      INPUT_TEXT_ALIGN[alignInput || 'left'],
      { 'icon-input': !!backgroundImage },
      THEME_CONTEXT.inputType,
    ),
    id: input.name,
    backgroundImage,
    ...input,
    onChange: handleOnChange,
    ...rest,
    ...{
      maxLength,
      placeholder,
      error,
    },
    ...(error &&
      touched && {
        modifier: 'error',
        message: error,
      }),
    fullWidth: fullWidth,
    valid,
    inputType,
    format,
    prefix,
    InputComponent: inputComponent(format, prefix),
  };

  return (
    <div className={classNames(classNameFieldset)}>
      <TextFieldWrapper touched={touched} inputEmpty={isInputEmpty && touched} error={error} {...inputProps}>
        <TextField
          label={labelOptions.text}
          {...inputProps}
          focus={active}
          style={{ ...(backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}) }}
        >
          {labelOptions?.tooltipHelper}
        </TextField>
      </TextFieldWrapper>
      {descriptionField && <p className={descriptionField.className}>{descriptionField.text}</p>}
    </div>
  );
};
